import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router";
import { Button } from "@gravity-ui/uikit";
import { RoutesList } from "@/router/routesList";
import { GameTimeFrame } from "@/store/api";
import { useSetPageData } from "@/tools/hooks";
import { PersonalGamesList } from "./components/PersonalGamesList";
import { PublicGamesList } from "./components/PublicGamesList";
/** Страница списка игр */
export var GamesListPage = function (props) {
    var navigate = useNavigate();
    var personalClickHandler = function () {
        navigate(props.timeFrame === GameTimeFrame.All
            ? RoutesList.Game.getPersonalAllGamesList()
            : props.timeFrame === GameTimeFrame.Past
                ? RoutesList.Game.getPersonalPastGamesList()
                : RoutesList.Game.getPersonalGamesList());
    };
    var publicClickHandler = function () {
        navigate(props.timeFrame === GameTimeFrame.All
            ? RoutesList.Game.getAllGamesList()
            : props.timeFrame === GameTimeFrame.Past
                ? RoutesList.Game.getPastGamesList()
                : RoutesList.Game.getGamesList());
    };
    var upcomingClickHandler = function () {
        navigate(props.isPersonal
            ? RoutesList.Game.getPersonalGamesList()
            : RoutesList.Game.getGamesList());
    };
    var pastClickHandler = function () {
        navigate(props.isPersonal
            ? RoutesList.Game.getPersonalPastGamesList()
            : RoutesList.Game.getPastGamesList());
    };
    var allClickHandler = function () {
        navigate(props.isPersonal
            ? RoutesList.Game.getPersonalAllGamesList()
            : RoutesList.Game.getAllGamesList());
    };
    useSetPageData({ title: "Игры" });
    return (_jsxs("div", { children: [_jsxs("div", { className: "g-s__py_4", children: [_jsx(Button, { view: "normal", onClick: personalClickHandler, size: "l", selected: props.isPersonal, pin: "circle-clear", children: "\u041C\u043E\u0438" }), _jsx(Button, { view: "normal", onClick: publicClickHandler, selected: !props.isPersonal, size: "l", pin: "clear-circle", children: "\u0412\u0441\u0435" })] }), _jsxs("div", { className: "g-s__py_4", children: [_jsx(Button, { view: "normal", onClick: upcomingClickHandler, size: "l", selected: !props.timeFrame, pin: "circle-clear", children: "\u0411\u043B\u0438\u0436\u0430\u0439\u0448\u0438\u0435" }), _jsx(Button, { view: "normal", onClick: pastClickHandler, size: "l", selected: props.timeFrame === GameTimeFrame.Past, pin: "clear-clear", children: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044B\u0435" }), _jsx(Button, { view: "normal", onClick: allClickHandler, selected: props.timeFrame === GameTimeFrame.All, size: "l", pin: "clear-circle", children: "\u0412\u0441\u0435" })] }), props.isPersonal ? (_jsx(PersonalGamesList, { timeFrame: props.timeFrame })) : (_jsx(PublicGamesList, { timeFrame: props.timeFrame }))] }));
};
